<template>
  <div class="flex flex-col min-h-0 min-w-0 w-full h-full">
    <div
      class="border-b border-mid-neutral-50 h-14 flex items-center justify-between px-6 bg-white z-10 shrink-0"
    >
      <div class="flex items-center gap-2 text-dark-neutral-500">
        <span class="material-symbols-outlined">account_circle</span>
        <h2 class="font-semibold">User</h2>
      </div>
    </div>
    <Specifications :composable="composable" />
  </div>
</template>
<script setup lang="ts">
import { Specifications, useSpecifications } from "specifications";
import { lifecyclePhasesState } from "states/lifecyclePhases";
import { useUsersSpecificationMetadataState } from "states/user";
import { variantsState } from "states/variants";
import { useRouter } from "vue-router";

const variants = variantsState();
const { phases } = lifecyclePhasesState();
const router = useRouter();
const userSpecs = useUsersSpecificationMetadataState();
const composable = useSpecifications({
  variants,
  phases,
  specificationsState: userSpecs,
  onSpecificationClick: (specification) => {
    router.push(`/compliance/user/specification/${specification.id}`);
  },
});
</script>
